import React from 'react';
import { Edit, Trash2, Layers } from 'lucide-react';

const TemplateCard = ({ template, onDelete, onEdit, onView }) => {
  return (
    <div 
      className="flex flex-col bg-card rounded-xl shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05)] outline outline-1 outline-border hover:shadow-md transition-all cursor-pointer relative overflow-hidden group min-h-[220px]"
      onClick={() => onView ? onView(template.id) : onEdit(template)} 
    >
      <div className="self-stretch p-5 flex flex-col justify-start items-start gap-4">
        {/* Template Title & Icon */}
        <div className="self-stretch inline-flex justify-start items-center gap-3">
          <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full border border-border bg-muted">
            <Layers className="w-5 h-5 text-foreground" />
          </div>
          <div className="flex-1 inline-flex flex-col justify-start items-start overflow-hidden">
            <h2 
              className="self-stretch text-foreground text-base font-semibold font-['Inter'] leading-6 truncate"
              title={template.title}
            >
              {template.title}
            </h2>

          </div>
        </div>

        {/* Stages Preview */}
        {template.status && Array.isArray(template.status) && template.status.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mt-1">
            {template.status.slice(0, 3).map((stage, index) => (
              <div
                key={index}
                className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-medium bg-muted border border-border text-muted-foreground"
              >
                <div
                  className="w-1.5 h-1.5 rounded-full"
                  style={{ backgroundColor: stage.bg_color || '#98A2B3' }}
                />
                <span className="truncate max-w-[60px]">{stage.name}</span>
              </div>
            ))}
            {template.status.length > 3 && (
              <span className="text-[10px] font-medium text-muted-foreground px-1 py-0.5">
                +{template.status.length - 3} more
              </span>
            )}
          </div>
        )}
      </div>

      {/* Card Footer / Actions */}
      <div className="mt-auto self-stretch flex flex-col justify-start items-center">
        <div className="self-stretch h-px bg-border" />
        <div className="self-stretch px-5 py-4 inline-flex justify-between items-center gap-4">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onEdit(template);
            }}
            className="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-2 text-sm font-semibold"
            title="Edit Template"
          >
            <Edit className="w-4 h-4" />
            Edit
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onDelete(template.id);
            }}
            className="text-muted-foreground hover:text-red-600 transition-colors"
            title="Delete Template"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TemplateCard;

